import { create } from 'zustand'

import { ApplicationPaginated } from '../hooks/usePaginateApplications'

interface ManageApplicationStore {
  application: ApplicationPaginated | null
  setApplication: (application: ApplicationPaginated | null) => void
}

export const useManageApplicationStore = create<ManageApplicationStore>(
  (set) => ({
    application: null,
    setApplication: (application) => set({ application }),
  }),
)
